export const BaseUrl = process.env.REACT_APP_API_URL;
export const CollectionUrl = process.env.REACT_APP_COLLECTION_URL;
export const IotUrl = process.env.REACT_APP_IOT_URL;
